import Helpers from '@/helpers.js'

const debugLog = (message, context) => {
  if (typeof window !== 'undefined' && window.__CB_DEBUG_BUCKET__) {
    console.log('[BucketDataProvider]', message, context != null ? context : '')
  }
}

export default {
  store: {},
  caseTypeId: 0,
  bucketId: 0,
  async loadAll(caseTypeId, bucketId, page) {
    this.store.dispatch("startBucketLoading")
    this.caseTypeId = caseTypeId
    this.bucketId = bucketId
    const preferences = this.store.state.currentUser.me.preferences
    const caseType = Helpers.getCaseTypeById(this.store.state, caseTypeId)
    if (!caseType) {
      debugLog('Defensive: no caseType in store, stopping load', { caseTypeId, bucketId })
      console.warn('[BucketDataProvider] loadAll: caseType not found in store (direct navigation?). caseTypeId=', caseTypeId, 'bucketId=', bucketId)
      this.store.dispatch("stopBucketLoading")
      return
    }
    // If bucket isn't in caseType.buckets (e.g. direct URL, or buckets list not loaded), load it directly by ID
    let bucketData = this.getBucket(caseType, bucketId)
    const bucketIdToLoad = (bucketData && bucketData.id) ? bucketData.id : parseInt(bucketId, 10)
    if (!bucketData || !bucketData.id) {
      debugLog('Bucket not in caseType.buckets – loading bucket directly by ID', { caseTypeId, bucketId, bucketIdToLoad })
      console.warn('[BucketDataProvider] loadAll: bucket not in store, loading bucket directly by id. bucketId=', bucketId)
    }

    // Check for sort parameters and page number in the current route
    const currentRoute = this.store.state.cbroute || {}
    const routeQuery = currentRoute.query || {}
    const sortField = routeQuery.sortField
    const sortDirection = routeQuery.sortDirection
    const urlPage = routeQuery.page

    // Use page from URL if available, otherwise use the passed page parameter
    const pageToUse = urlPage ? parseInt(urlPage, 10) : page

    await this.store.dispatch('getBucket', {
      bucketId: bucketIdToLoad,
      page: pageToUse,
      pageSize: preferences.pageSize,
      sortField: sortField,
      sortDirection: sortDirection
    })
    this.setupData(caseType, this.store.state.buckets.current.bucket, preferences)
  },
  async reload(page, sortField, isDesc) {
    this.store.dispatch("startBucketLoading")
    const caseType = Helpers.getCaseTypeById(this.store.state, this.caseTypeId)
    const me = this.store.state.currentUser.me
    const payload = {
      bucketId: this.bucketId,
      page: page,
      pageSize: me.preferences.pageSize,
    }
    if (sortField != null && String(sortField).trim() !== "") {
      payload.sortField = sortField
      payload.descending = !!isDesc
    }
    await this.store.dispatch('getBucket', payload)
    this.setupData(caseType, this.store.state.buckets.current.bucket, this.store.state.currentUser.me.preferences)
  },
  async setupData(caseType, bucket, preferences) {
    const schemaData = Helpers.prepareBucketSchema(caseType, bucket)
    const bucketHeaderLink = Helpers.getBucketHeaderLink(schemaData)
    const headers = Helpers.formatBucketHeaders(schemaData, bucketHeaderLink)
    let cases = []
    if (bucket && bucket.contents) { cases = bucket.contents.cases }
    const slcId = bucket.serviceLevel ? bucket.serviceLevel.id : undefined
    const currentCases = await Helpers.formatBucketData(schemaData, cases, preferences, slcId, bucketHeaderLink)
    const schema = schemaData.schema
    this.store.dispatch("setupBucket", { caseType, bucket, headers, currentCases, schema })
  },
  getBucket(caseType, bucketId) {
    if (caseType.buckets) {
      return caseType.buckets.find((currentBucket) => parseInt(currentBucket.id, 10) === parseInt(bucketId, 10))
    } else {
      return {}
    }
  }
}
